import React from "react";
import PropTypes from "prop-types";
import { SFStack } from "../../../grid";
import SFTypography from "../../../typography";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const SFStackStyled = styled(SFStack)(({ theme }) => ({
  height: "100%",
  width: "100%",
  cursor: "pointer",
}));

const ClickableTextRenderer = ({
  data,
  labelField,
  getLabel,
  onClick,
  variant = "tableList",
}) => {
  if (!data) return null;
  return (
    <SFStackStyled
      justifyContent="center"
      {...(onClick && { onClick: () => onClick(data) })}
    >
      <SFTypography variant={variant} className="max-1-lines">
        {getLabel ? getLabel(data) : data[labelField]}
      </SFTypography>
    </SFStackStyled>
  );
};

ClickableTextRenderer.propTypes = {
  // data of the row
  data: PropTypes.object,
  // field of the data to be displayed
  labelField: PropTypes.string,
  // function that returns the label to be displayed based on the data
  getLabel: PropTypes.func,
  // variant of the text
  variant: PropTypes.string,
  // function to be called when the text is clicked
  onClick: PropTypes.func,
};

export default ClickableTextRenderer;
